// ** Third Party Components
import { HelpCircle} from 'react-feather'

// ** Reactstrap Imports
import { UncontrolledDropdown, DropdownMenu, DropdownItem, DropdownToggle } from 'reactstrap'

const NavbarHelp = () => {

  function displayHelp() {
    const language = localStorage.getItem('i18nextLng').substring(0, 2)
    const path = window.location.pathname.replace("/pages", "")
    window.open(`https://wiki.optimahr.app/${language}${path}`, '_blank')
//    window.open(`https://wiki.optimahr.app/en${path}`, '_blank')
  }

  return (
    <UncontrolledDropdown tag='li' className='dropdown-config nav-item'>
      <DropdownToggle href='/' tag='a' className='nav-link dropdown-config-link' onClick={e => e.preventDefault()}>
        <HelpCircle className='ficon' onClick={() => displayHelp()} />
      </DropdownToggle>
    </UncontrolledDropdown>
  )
}

export default NavbarHelp
